import AdminTool from './adminTool'
export default AdminTool
